import { render } from "./CarouselManagement.vue?vue&type=template&id=bab760fa"
import script from "./CarouselManagement.vue?vue&type=script&lang=js"
export * from "./CarouselManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__